import { HttpClient } from '../../httpClient'
import type {
  ReadContentVersionDocument,
  UpdateContentVersionLabelBody,
} from './types'

/** Updates the label on a single version. `null` clears the label. */
export const updateContentVersionLabel = async ({
  id,
  label,
}: {
  id: string
  label: string | null
}): Promise<ReadContentVersionDocument> => {
  const url = new URL(`/v3/content_versions/${id}`, window.location.origin)

  const body: UpdateContentVersionLabelBody = {
    data: { id, type: 'content_version', attributes: { label } },
  }

  return HttpClient()
    .patch(url.toString(), body)
    .then((res) => res.data)
}
